export const TOAST_TIMEOUT = 3000;

export type ProfileApiResponse = {
  total: number;
  offset: number;
  count: number;
  accountSearch: Value[];
};

interface Value {
  accountNumber: number;
  accountName: AccountName;
  accountType: string;
  lastRenewedDate: string;
  expirationDate: string;
  countryCode: string;
  renewalFlag: string;
  status: string;
  profile: Profile;
  blocksPrivilegesList: BlocksPrivilegesList[];
  uplinePlatinumAccount: string;
  uplineSponsorAccount: string;
  uplineDiamondAccount: string;
}

interface AccountName {
  name: string;
  characterType: string;
}

interface Profile {
  profileId: string;
  roleCode: string;
  citizenshipType: string;
  primary: boolean;
  displayGivenName: string;
  displayFamilyName: string;
}

interface BlocksPrivilegesList {
  blockId: string;
  isBlock: boolean;
}

export const ErrorActionType = {
  ShowPopup: 'SHOW_POPUP',
  DisableCheckout: 'DISABLE_CHECKOUT',
} as const;
